import React, { useContext } from 'react'
import styled from 'styled-components'
import { LayoutContext } from '../../contexts'
import Video from '../shared/Video'

const TechnologyHero = ({ heroHeading, heroBody, heroVideo }) => {
  const { node_locale } = useContext(LayoutContext)

  return (
    <StyledHero>
      <Wrapper>
        <Header>{heroHeading}</Header>
        <Body>{heroBody.heroBody}</Body>
      </Wrapper>
      <StyledVideo
        mp4={heroVideo.videoMp4.file.url}
        webm={heroVideo.videoWebm.file.url}
        poster={heroVideo.poster.fluid}
        controls={node_locale === 'en-US'}
      />
    </StyledHero>
  )
}

const StyledHero = styled.section`
  position: relative;
`

const Wrapper = styled.div`
  color: white;
  padding: ${(props) => props.theme.space.marginMobile * 8}vw
    ${(props) => props.theme.space.marginMobile * 4}vw
    ${(props) => props.theme.space.marginMobile * 16}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding: ${(props) => props.theme.space.marginDesktop * 16}vw
      ${(props) => props.theme.space.marginDesktop * 23}vw
      ${(props) => props.theme.space.marginDesktop * 33}vw;
  }
`

const Header = styled.h1`
  font-size: 12vw;
  line-height: 1.2;
  padding-bottom: ${(props) => props.theme.space.marginMobile * 2}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: 12.5vw;
    line-height: 1;
    padding-bottom: ${(props) => props.theme.space.marginDesktop * 6}vw;
  }

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    width: 100%;
  }
`

const Body = styled.div`
  font-size: ${(props) => props.theme.fontSize.m35};
  line-height: 1.4;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d25};
    padding-left: ${(props) => props.theme.space.marginDesktop * 1.5}vw;
    padding-right: ${(props) => props.theme.space.marginDesktop * 10}vw;
  }
`

const StyledVideo = styled(Video)`
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
`

export default TechnologyHero
